import { SseEventBase } from './sse-event-base.model';
import { SseEventType } from './sse-event-type.model';
import { runInInjectionContext } from '@angular/core';
import { NotificationReasonEnum } from '../../enums/notification/notification-reason.enum';
import { take } from 'rxjs/operators';
import { MessageDesignBUtils } from '../../content/components/message-design-b/message-design-b.utils';

export class SseMultiObjectEvent extends SseEventBase {

  type: SseEventType = 'multiObject';
  onMessage = (event: MessageEvent<any>): void => {
    const resp = JSON.parse(event.data);

    if (this.hasEvents(resp)) {
      runInInjectionContext(this.injector, () => {
        resp.events.forEach(event => this.onEvent(resp, event));
      });
    }
  }

  private onEvent(resp: any, event: NotificationReasonEnum): void {
    this.ngZone.run(() => {
      switch (event) {
        case NotificationReasonEnum.MULTI_OBJECT_CREATE_SUCCESS: {
          setTimeout(() => {
            this.on.multiObjectCreated$.next(resp.targetId);
            const ids = new Set<number>();
            ids.add(resp.millis);
            this.inProgressMessageService.removeMessage(resp.demandId);
            const message = MessageDesignBUtils.createMultiObjectContainerSuccess(resp.targetId);
            this.messageClientService.messages$.next(message);
          }, 500);
          break;
        }
        case NotificationReasonEnum.MULTI_OBJECT_CREATE_FAILED: {
          setTimeout(() => {
            this.inProgressMessageService.removeMessage(resp.demandId);
            this.messageClientService.messages$.next(MessageDesignBUtils.createMultiObjectContainerFailed());
          }, 500);
          break;
        }
        case NotificationReasonEnum.MULTI_OBJECT_RENTAL: {
          this.on.multiObjectDynamicCountIds$.next(new Set(resp.bulkIds));
          if (resp.hasNewObject) {
            this.on.collectionCreated$.next(true);
          }
          break;
        }
      }
    });
  }
}
